/* eslint-disable import/no-default-export */
import React from 'react';

import AttachmentIcon from '../../icons/AttachmentIcon';

import IconBadge from './IconBadge';

const AttachmentsBadge = ({ numAttachments = 0 }) => (
  <IconBadge icon={<AttachmentIcon />}>{numAttachments}</IconBadge>
);

export default AttachmentsBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/AttachmentsBadge.js